import { render, staticRenderFns } from "./implementacion-medidas-autoridades.vue?vue&type=template&id=8044bcf6&"
import script from "./implementacion-medidas-autoridades.vue?vue&type=script&lang=js&"
export * from "./implementacion-medidas-autoridades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports